export enum AuthPathsEnum {
  ROOT = "authentication",
  LOGIN = "login",
  REGISTER = "register",
  FORGOT_PASSWORD = "forgot-password",
  RESET_PASSWORD = "reset-password",
  VERIFY_ACCOUNT = "verify-account/:verificationType",
  PERSONAL_INFORMATION_DETAILS = "personal-information-details/:fromSocial?",
}

export enum AuthRoutesEnum {
  ROOT = "/authentication",
  LOGIN = "/authentication/login",
  REGISTER = "/authentication/register",
  FORGOT_PASSWORD = "/authentication/forgot-password",
  RESET_PASSWORD = "/authentication/reset-password",
  VERIFY_ACCOUNT = "/authentication/verify-account/:verificationType",
  PERSONAL_INFORMATION_DETAILS = "/authentication/personal-information-details/:fromSocial?",
}
